import { usePhoneStore } from '@hit/react-jssip';
import { useCallback, useEffect } from 'react';

import { useProvider } from '@/hooks/use-provider';
import { PROVIDERS } from '@/providers';

export const useOnCallActionListener = () => {
  const phone = usePhoneStore((state) => state.phone);
  const [provider] = useProvider();

  const onCallAction = useCallback(
    (number: string) => {
      if (!phone) return;
      const digits = number.replace(/\D/g, '');
      phone.call(digits);
    },
    [phone]
  );

  useEffect(() => {
    if (provider.id === PROVIDERS.OMNIHIT) {
      provider.setCallListener(onCallAction);
    }
  }, [provider, onCallAction]);
};
